import Component from '../lib/Component'

export default class TabBox extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.tabLinks = [...this.elem.querySelectorAll('.js-TabBox__link')]
    this.tabContent = [...this.elem.querySelectorAll('.js-TabBox__content')]
    this.currentTabIndex = 0
  }
  
  updateTab (data) {
    if (this.currentTabIndex !== data.index) {
      this.tabLinks.forEach((link, index) => {
        if (index !== data.index) {
          this.removeClass('_is_current', link.parentElement)
          this.removeClass('_is_current', this.tabContent[index])
        } else {
          this.addClass('_is_current', data.tabLink.parentElement)
          this.addClass('_is_current', this.tabContent[data.index])
        }
      })
      this.currentTabIndex = data.index
    }
  }
  init () {
    this.tabLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        this.events.publish('TabBox:tabClicked', {tabLink: link, index: index})
        return false
      })
    })
    this.events.subscribe('TabBox:tabClicked', this.updateTab.bind(this))
  }
}
